export default "__VITE_ASSET__960f99f1__"